const requiredFieldsEight = [
  "passport",
  "statement",
  "transcript",
  "expects_letters",
  "expects_pastors",
];

export default requiredFieldsEight;
